export class EffectivePrivilege {
   ApplicationID: string = "";
   AppliesToOrganizationID: string = "";
   AssignedID: string = "";
   AssignmentLevel: string = "";
   Description: string = "";
   ID: string = "";
   Name: string = "";
   PrivilegeState!: PrivilegeState;
}

export enum PrivilegeState {
   Allow = 0,
   Deny = 1,
   Assign = 2,
   AllowAndLimitedAssign = 3,
}
